export default {
        //main sidebar menu options
    main: [
        { 
            sidebarName: 'Inicio', 
            sidebarIcon: 'house', 
            requiredValidation: true,
            validationRules: "this.user.isAdmin !== 1",
            routeTo: 'dashboard'
        },
        { 
            sidebarName: 'Inicio', 
            sidebarIcon: 'house', 
            requiredValidation: true,
            validationRules: "this.user.isAdmin === 1",
            routeTo: 'admin-dashboard'
        },
        { 
            sidebarName: 'Registro de Ventas', 
            sidebarIcon: 'clipboard-data',
            routeTo: 'ListadoVentas',
            requiredValidation: true,
            validationRules: "this.user.permissions.includes('can_access_punto_venta') && this.empresa.permissions.includes('can_use_module_punto_venta') && this.user.tipo_terceros == 1"
        },
        { 
            sidebarName: 'Catálago Propio', 
            sidebarIcon: 'card-list', 
            recursive: true,
            toMenu: 1,
            requiredValidation: true,
            validationRules: "this.user.permissions.includes('can_edit_items_empresa') && this.empresa.permissions.includes('can_use_module_items_empresa')",
        },
        { 
            sidebarName: 'Otras Categorías', 
            sidebarIcon: 'card-list',
            requiredValidation: true,
            validationRules: "this.user.isAdmin !== 1 && this.categoriesEmpresa.length > 0",
            recursive: true,
            toMenu: "C0",
        },
        { 
            sidebarName: 'Vendedores', 
            sidebarIcon: 'person',
            routeTo: 'listadoUsuarios',
            requiredValidation: true,
            validationRules: "this.user.permissions.includes('can_access_users_list')"
        },
        { 
            sidebarName: 'Comisiones', 
            sidebarIcon: 'person',
            routeTo: 'SalesCommissionTrackerList',
            requiredValidation: true,
            validationRules: "this.user.permissions.includes('can_supervise_sales_comission')"
        },
        { 
            sidebarName: 'Clientes', 
            sidebarIcon: 'person',
            routeTo: 'ListadoClientes',
            requiredValidation: true,
            validationRules: "this.user.permissions.includes('can_access_users_list')"
        },
        { 
            sidebarName: 'Pedidos', 
            sidebarIcon: 'clipboard-data',
            routeTo: 'ListadoPedidosClienteWeb',
            requiredValidation: true,
            validationRules: "this.user.tipo_terceros == 2"
        },
        { 
            sidebarName: 'Pedidos Terceros', 
            sidebarIcon: 'clipboard-data',
            routeTo: 'ListadoPedidos',
            requiredValidation: true,
            validationRules: "this.user.isAdmin !== 1 && this.user.tipo_terceros == 1"
        },
        { 
            sidebarName: 'Pedidos Api', 
            sidebarIcon: 'clipboard-data',
            routeTo: 'ordersListApi',
            requiredValidation: true,
            validationRules: "this.user.isMaster == 1 && this.empresa.permissions.includes('can_use_module_api')"
        },
        { 
            sidebarName: 'Pedidos Proveedor', 
            sidebarIcon: 'clipboard-data',
            routeTo: 'getPedidosProveedor',
            requiredValidation: true,
            validationRules: "this.user.permissions.includes('orders_prov_supervisor') || this.user.permissions.includes('can_orders_prov')"
        },
        { 
            sidebarName: 'Precios Personalizados', 
            sidebarIcon: 'layout-text-sidebar-reverse',
            routeTo: 'preciosPersonalizadosList',
            requiredValidation: true,
            validationRules: "this.user.permissions.includes('can_edit_precios_personalizados') && this.opcionPrecioPropio === 2"
        },
        { 
            sidebarName: 'Categorías', 
            sidebarIcon: 'card-list',
            recursive: true,
            toMenu: "S0",
            requiredValidation: true,
            validationRules: "this.user.isAdmin !== 1"
        },
        { 
            sidebarName: 'Configuraciones', 
            sidebarIcon: 'gear-fill',
            routeTo: 'configuracion',
            requiredValidation: true,
            validationRules: "this.user.permissions.includes('can_edit_configuration')"
        },
        { 
            sidebarName: 'Configuracion Web', 
            sidebarIcon: 'gear-fill',
            routeTo: 'configuracionClienteWeb',
            requiredValidation: true,
            validationRules: "this.user.permissions.includes('can_edit_configuration')"
        },
        { 
            sidebarName: 'Configuracion odoo', 
            sidebarIcon: 'gear-fill',
            routeTo: 'configuracionClienteOdoo',
            requiredValidation: true,
            validationRules: "this.user.isMaster == 1 && this.empresa.permissions.includes('can_use_module_own_odoo')"
        },
        { 
            sidebarName: 'Empresas', 
            sidebarIcon: 'card-list',
            routeTo: 'companiesList',
            requiredValidation: true,
            validationRules: "this.user.isAdmin == 1"
        },
        {
            sidebarName: 'Usuarios',
            sidebarIcon: 'people',
            routeTo: 'usersListAdmin',
            requiredValidation: true,
            validationRules: "this.user.isAdmin == 1"
        },
        {
            sidebarName: 'Items recomendados',
            sidebarIcon: 'grid-fill',
            routeTo: 'recomendedItemsList',
            requiredValidation: true,
            validationRules: "this.user.isAdmin == 1"
        },
        {
            sidebarName: 'Banners',
            sidebarIcon: 'card-image',
            routeTo: 'configurationBanners',
            requiredValidation: true,
            validationRules: "this.user.isAdmin == 1"
        },
        { 
            sidebarName: 'Perfil', 
            sidebarIcon: 'person-circle',
            routeTo: 'perfil'
        },
    ],
    items_config: [
        { 
            sidebarName: 'Volver', 
            sidebarIcon: 'caret-left-fill', 
            toMenu: 0,
        },
        { 
            sidebarName: 'Items', 
            sidebarIcon: 'grid-fill',
            routeTo: 'GetItemsListEmpresa',
            requiredValidation: true,
            validationRules: "this.empresa.permissions.includes('can_use_module_items_empresa')"
        },
        {
            sidebarName: 'Items Archivados',
            sidebarIcon: 'archive-fill',
            routeTo: 'GetItemsArchivedListEmpresa',
            requiredValidation: true,
            validationRules: "this.empresa.permissions.includes('can_use_module_items_empresa')"
        },
        { 
            sidebarName: 'Categorías', 
            sidebarIcon: 'card-list',
            routeTo: 'GetCategoriesListEmpresa',
            requiredValidation: true,
            validationRules: "this.empresa.permissions.includes('can_use_module_items_empresa')"
        }
        ,
        { 
            sidebarName: 'Atributos', 
            sidebarIcon: 'card-checklist',
            routeTo: 'GetAttributesListEmpresa',
            requiredValidation: true,
            validationRules: "this.empresa.permissions.includes('can_use_module_items_empresa')"
        }
        ,
        { 
            sidebarName: 'Lista de Precios', 
            sidebarIcon: 'card-list',
            routeTo: 'getPriceListEmpresa',
            requiredValidation: true,
            validationRules: "this.empresa.permissions.includes('can_use_module_items_empresa')"
        }
    ],
}
